import { Address } from "../types/address";

export const defaultValues: Address = {
  dp: '',
  ine: '',
  nv: '',
  pnp: '',
  poblacio: '',
  state: '',
  tv: '',
  aclarador: '',
  bq: '',
  es: '',
  pt: '',
  pu: '',
  ref_catastral: '',
}